import React, { useEffect, useState } from 'react';
import { material } from '../../../library/material';
import Snackbar from '../../toastrmessage/Snackbar';
import { getSentMailData } from '../../../services/PatientService';


function PatientSentEmail(props) {
    const { openPatientSentEmail, setOpenPatientSentEmail, patientData } = props;

    const [openSnackBar, setOpenSnackBar] = useState({
        "action": false,
        "type": "",
        "message": "",
    });

    const [emailList, setEmailList] = useState([]); // List of all emails
    const [filteredEmailData, setFilteredEmailData] = useState([]); // Filtered emails based on search
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState(""); // Search input state
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    // const [replyMessage, setReplyMessage] = useState("");

    // const [attachment, setAttachment] = useState(null);

    useEffect(() => {
        if (openPatientSentEmail) {
            fetchEmails();
        }
    }, [openPatientSentEmail]);

    useEffect(() => {
        filterEmails();
    }, [searchQuery, emailList]);

    const fetchEmails = () => {
        setLoading(true);
        getSentMailData(patientData.email)
            .then((resp) => {
                let rawEmailData = resp.data?.data;

                if (typeof rawEmailData === "string") {
                    rawEmailData = [rawEmailData]; // Convert single string to array
                }

                if (Array.isArray(rawEmailData)) {
                    const parsedEmails = rawEmailData.map((htmlString) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(htmlString, "text/html");

                        // Function to clean up extracted text
                        const cleanText = (selector) => {
                            return (doc.querySelector(selector)?.innerText || "Unknown")
                                .replace(/\s+/g, " ") // Remove extra spaces & newlines
                                .trim();
                        };

                        // Function to clean and format the email body content
                        const cleanHtmlContent = (html) => {
                            return html
                                .replace(/\s+/g, " ") // Remove excessive spaces and new lines
                                .replace(/<br\s*\/?>/gi, "") // Remove <br> tags
                                .replace(/&nbsp;/g, " ") // Remove non-breaking spaces
                                .trim();
                        };

                        return {
                            subject: cleanText("h3").replace("Subject:", "").trim(),
                            from: cleanText("p:nth-of-type(2)").replace("From:", "").trim(),
                            timestamp: cleanText("p:nth-of-type(3)").replace("Sent At:", "").trim(),
                            content: cleanHtmlContent(doc.body.innerHTML), // Clean email body content
                        };
                    });

                    setEmailList(parsedEmails);
                    setFilteredEmailData(parsedEmails);
                } else {
                    console.warn("Expected an array but got:", rawEmailData);
                    setEmailList([]);
                    setFilteredEmailData([]);
                }

                setOpenSnackBar({
                    action: true,
                    type: "success",
                    message: resp.data.message,
                });
            })
            .catch((error) => {
                console.error("Error fetching emails:", error);
                setEmailList([]);
                setFilteredEmailData([]);
                setOpenSnackBar({
                    action: true,
                    type: "error",
                    message: error.message,
                });
            })
            .finally(() => setLoading(false));
    };


    const filterEmails = () => {
        if (searchQuery.trim() === "") {
            setFilteredEmailData(emailList);
        } else {
            const filtered = emailList.filter((email) =>
                email.subject.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredEmailData(filtered);
        }
        setCurrentPage(0); // Reset to first page after filtering
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleChangePage = (_, newPage) => {
        setCurrentPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(0);
    };

    // const backToList = () => setSelectedEmail(null);
    const backToList = () => {
        setSelectedEmail(null);
        // setReplyMessage("");
        // setAttachment(null);
    };

    // const handleAttachmentChange = (event) => {
    //     setAttachment(event.target.files[0]);
    // };

    // const handleReplySubmit = async () => {
    //     if (!replyMessage.trim()) {
    //         setOpenSnackBar({ action: true, type: "error", message: "Reply message cannot be empty" });
    //         return;
    //     }
    //     const data = new FormData();
    //     data.append("to", selectedEmail.from);
    //     data.append("subject", `${selectedEmail.subject}`);
    //     data.append("message", replyMessage);
    //     // if (attachment) {
    //     data.append("attachment", attachment);
    //     // }

    //     try {
    //         await sendPatientReplyEmailData(data);
    //         setOpenSnackBar({ action: true, type: "success", message: "Reply sent successfully" });
    //         backToList();
    //     } catch (error) {
    //         setOpenSnackBar({ action: true, type: "error", message: "Failed to send reply" });
    //     }
    // };

    const handleClose = () => {
        setOpenPatientSentEmail(false)
    }

    return (
        <div>
            <material.Dialog open={Boolean(openPatientSentEmail)} fullWidth maxWidth="lg">
                <material.DialogTitle>
                    Patient Sent Email
                    <span className='float-end'>
                        <material.IconButton title='Close' color='error' onClick={handleClose}>
                            <material.CloseIcon sx={{ cursor: "pointer" }} />
                        </material.IconButton>
                    </span>
                </material.DialogTitle>
                <material.DialogContent>
                    <material.Grid container spacing={2}>
                        <material.Grid item xs={12}>
                            <material.Stack direction="row" spacing={1} justifyContent="flex-end">
                                {selectedEmail ? (
                                    <material.Button variant="contained" sx={{ textTransform: "none", mr: 1 }} size="small" onClick={backToList}>
                                        Back
                                    </material.Button>
                                ) : (null)}
                            </material.Stack>
                        </material.Grid>


                        {!selectedEmail ? (
                            <material.Grid item xs={12}>
                                <material.Paper sx={{ width: "100%", overflow: "hidden", p: 2 }}>
                                    <material.Grid item xs={12} sm={2} md={2} lg={2}>
                                        <material.TextField
                                            fullWidth
                                            label="Search by Subject"
                                            variant="standard"
                                            size="small"
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                            sx={{ mb: 2 }}
                                        />
                                    </material.Grid>

                                    {loading ? (
                                        <material.Box
                                            sx={{
                                                display: "grid",
                                                placeItems: "center",
                                                height: "100vh",
                                                width: "100vw",
                                                position: "fixed",
                                                top: 0,
                                                left: 0,
                                            }}
                                        >
                                            <material.CircularProgress />
                                        </material.Box>
                                    ) : filteredEmailData.length === 0 ? (
                                        <h3 style={{ color: "red", textAlign: "center" }}>No emails found</h3>
                                    ) : (
                                        <>
                                            <material.TableContainer>
                                                <material.Table>
                                                    <material.TableHead>
                                                        <material.TableRow>
                                                            <material.TableCell><strong>Email</strong></material.TableCell>
                                                            <material.TableCell><strong>Subject</strong></material.TableCell>
                                                            <material.TableCell align="right"><strong>Date</strong></material.TableCell>
                                                        </material.TableRow>
                                                    </material.TableHead>
                                                    <material.TableBody>
                                                        {filteredEmailData
                                                            .slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage)
                                                            .map((email, index) => (
                                                                <material.TableRow
                                                                    key={index}
                                                                    onClick={() => setSelectedEmail(email)}
                                                                    sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
                                                                >
                                                                    <material.TableCell sx={{ fontWeight: "bold" }}>{email.from}</material.TableCell>
                                                                    <material.TableCell>
                                                                        <span style={{ fontWeight: email.isImportant ? "bold" : "normal" }}>
                                                                            {email.subject}
                                                                        </span>
                                                                    </material.TableCell>
                                                                    <material.TableCell align="right">{email.timestamp}</material.TableCell>
                                                                </material.TableRow>
                                                            ))}
                                                    </material.TableBody>
                                                </material.Table>
                                            </material.TableContainer>

                                            <material.TablePagination
                                                rowsPerPageOptions={[5, 10, 50]}
                                                component="div"
                                                count={filteredEmailData.length}
                                                rowsPerPage={rowsPerPage}
                                                page={currentPage}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                            />
                                        </>
                                    )}
                                </material.Paper>
                            </material.Grid>
                        ) : (
                            <material.Grid item xs={12}>
                                <material.Paper sx={{ width: "100%", overflow: "hidden", p: 2 }}>
                                    <div dangerouslySetInnerHTML={{ __html: selectedEmail.content }} />
                                    {/* <material.TextField fullWidth label="Reply" multiline rows={4} value={replyMessage} onChange={(e) => setReplyMessage(e.target.value)} sx={{ mt: 2 }} />
                                    <material.Input type="file" onChange={handleAttachmentChange} sx={{ mt: 2, my: 2 }} />
                                    <material.Button variant="contained" onClick={handleReplySubmit} sx={{ mt: 2, my: 3 }}>Send Reply</material.Button> */}
                                </material.Paper>
                            </material.Grid>
                        )}
                    </material.Grid>
                </material.DialogContent>
            </material.Dialog>
            <Snackbar
                openSnackBar={openSnackBar}
                setOpenSnackBar={setOpenSnackBar}
            />
        </div>
    )
}

export default PatientSentEmail